import {useContext, useMemo} from 'react';
import * as R from 'ramda';
import {userCtx} from '../auth';
import {SystemConfigCtx} from '@/contexts';

const permissions = {
  canAccessB2CPages: context => {
    const {user} = context;
    return user.currentClient;
  },
  canAccessB2BPages: context => {
    const {user} = context;
    return user.currentProducer;
  },
  canAccessInternalPages: context => {
    const {user} = context;
    return user.currentStaff;
  },
  canAccessB2BCommission: context => {
    const {user} = context;
    return user.currentProducer.hasCommissionPermission;
  },
  canAccessBvReport: context => {
    const {user} = context;
    return user.currentProducer.hasBvReportPermission;
  },
  canAccessTraningHistoryReport: context => {
    const {user} = context;
    return user.currentProducer.hasTrainingHistoryReportPermission;
  },
  canAccessAvenueB2b: context => {
    const {user} = context;
    return user.currentProducer.hasAvenueB2bLogin;
  },
  enableInternalPages: context => {
    const {systemConfig} = context;
    return systemConfig.feature.internal === 'true';
  },
  enableExternalPages: context => {
    const {systemConfig} = context;
    return systemConfig.feature.external === 'true';
  },
};

const usePermission = () => {
  const user = useContext(userCtx);
  const {systemConfig} = useContext(SystemConfigCtx);

  return useMemo(
    () => {
      const permissionContext = {user, systemConfig};
      return R.map(
        itemFn => (...rest) => itemFn(permissionContext, ...rest),
        permissions
      );
    },
    [user]
  );
};

export default usePermission;
